export enum Exports {
  AutomaticDatev = "automatic_datev",
  LineItems = "line_items",
  Invoices = "invoices",
  Suppliers = "suppliers",
  Datev = "datev",
  Pdf = "pdf",
}
